function Benefits() {
  return (
    <section className="benefits-section">
      <div className="benefits-grid">
        <article className="benefit-item">
          <div className="benefit-icon">⚡</div>

          <div>
            <h3>Fast Staffing</h3>
            <p>Qualified professionals when your facility needs them.</p>
          </div>
        </article>

        <article className="benefit-item">
          <div className="benefit-icon">✓</div>

          <div>
            <h3>Verified Professionals</h3>
            <p>
              Credentials, experience and registration carefully reviewed.
            </p>
          </div>
        </article>

        <article className="benefit-item">
          <div className="benefit-icon">24</div>

          <div>
            <h3>24/7 Support</h3>
            <p>Responsive assistance for professionals and facilities.</p>
          </div>
        </article>

        <article className="benefit-item">
          <div className="benefit-icon">CA</div>

          <div>
            <h3>Canada-Wide Coverage</h3>
            <p>Flexible staffing support across Ontario and Canada.</p>
          </div>
        </article>
      </div>
    </section>
  );
}

export default Benefits;